import type { DiscoveredRouteModule } from '@/router/generator/types';

const BadGatewayView = () => import('@/views/error-pages/BadGatewayView.vue');
export const NAME_BAD_GATEWAY = 'BadGateway';
export const PATH_BAD_GATEWAY = '/bad-gateway';

export const route: DiscoveredRouteModule = {
  id: 'root.error.bad_gateway',
  scope: 'root',
  name: NAME_BAD_GATEWAY,
  path: PATH_BAD_GATEWAY,
  component: BadGatewayView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


